import script from "./App08大别山水系_完整版.vue?vue&type=script&setup=true&lang=js"
export * from "./App08大别山水系_完整版.vue?vue&type=script&setup=true&lang=js"

import "./App08大别山水系_完整版.vue?vue&type=style&index=0&id=891ab5be&lang=css"

const __exports__ = script;

export default __exports__